import { costFormatter } from '@format/currency';
import { getPronoun, PRONOUN_TYPES } from '../../pets';

export const interpolations = (pet, cart, subscriptionProducts) => {
  const { name: pupName } = pet;
  const subscription = cart.subscriptions[pet.id];

  try {
    const product = subscriptionProducts.find(
      product => product.variants[0].sku === subscription.sku,
    );
    return {
      frequency: product.weeks_of_food,
      numPacks: product.variants[0].tray_count,
      bagCount: product.variants[0].bag_count,
      pricePerWeek: costFormatter(product.variants[0].price_per_week),
      pupName,
      petPronoun: getPronoun(pet.gender, {
        type: PRONOUN_TYPES.POSSESSIVE_ADJECTIVE,
        perspective: 3,
      }),
    };
  } catch (err) {
    throw new Error(
      `${err}: cart value - ${JSON.stringify(
        cart,
      )}, pet value - ${JSON.stringify(
        pet,
      )}, subscription products - ${JSON.stringify(subscriptionProducts)}`,
    );
  }
};
